import React, { useState, useEffect } from "react";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import {
  CommonUrl,
  NONCE,
  TIME_STAMP,
  logoutMsg
} from "../common-url/CommonUrl";
import { shallowEqual, useSelector } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
import { useHistory } from "react-router";
import { toast } from "react-toastify";

export function DashboardPage({ className }) {
  const encToken = useSelector(({ auth }) => auth.authToken, shallowEqual);
  useEffect(() => {
    fetchDashboardDetails();
  }, [fetchDashboardDetails]);

  const history = useHistory();

  const [dashboardDetails, setDashboardDetails] = useState({});
  const fetchDashboardDetails = async () => {
    await fetch(CommonUrl.dashboardBaseUrl + "/all-details", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      }
    })
      .then(response => response.json())
      .then(response => {
        // console.log(response, "........response.........")
        if (response.code == 401) {
          history.push("/logout");
          toast.info(logoutMsg, { autoClose: 5000 });
        } else {
          setDashboardDetails(response);
        }
      });
  };
  return (
    <div className="">
      <div className="rounded bg-white py-20 px-20">
        <div className="row gy-4 d-flex flex-wrap  ">
          <div className="col-12 col-sm-6 col-lg-4">
            <div className="bg-light-primary px-14 py-8 rounded  ">
              <span className="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
                <Tooltip title="Master Users" interactive>
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Shield-user.svg"
                    )}
                  />
                </Tooltip>
                <span className="text-primary float-right font-weight-bold font-size-h1 mr-5">
                  {dashboardDetails.masterUsers}
                </span>
              </span>
              <p className="text-primary font-weight-bold font-size-h6">
                Master Users
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4">
            <div className="bg-light-success px-14 py-8 rounded ">
              <span className="svg-icon svg-icon-3x svg-icon-success d-block my-2">
                <Tooltip title="Subordinate Users">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                  ></SVG>
                </Tooltip>
                <span className="text-success float-right font-weight-bold font-size-h1 mr-5">
                  {dashboardDetails.subUsers}
                </span>
              </span>
              <p className="text-success font-weight-bold font-size-h6 mt-2">
                Sub-ordinate Users{" "}
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4">
            <div className="bg-light-warning px-14 py-8 rounded">
              <span className="svg-icon svg-icon-3x svg-icon-warning d-block my-2">
                <Tooltip title="Room Types">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Home/Door-open.svg")}
                  ></SVG>
                </Tooltip>
                <span className="text-warning float-right font-weight-bold font-size-h1 mr-5">
                  {dashboardDetails.roomTypes}
                </span>
              </span>
              <p className="text-warning font-weight-bold font-size-h6 mt-2">
                Room Types{" "}
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4">
            <div className="bg-light-primary px-14 py-8 rounded ">
              <span className="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
                <Tooltip title="Devices">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Devices/CPU1.svg")}
                  />
                </Tooltip>
                <span className="text-primary float-right font-weight-bold font-size-h1 mr-5">
                  {dashboardDetails.devices}
                </span>
              </span>
              <p className="text-primary font-weight-bold font-size-h6">
                Devices
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4">
            <div className="bg-light-success px-14 py-8 rounded  ">
              <span className="svg-icon svg-icon-3x svg-icon-success d-block my-2">
                <Tooltip title="Icons">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/General/Half-star.svg"
                    )}
                  />
                </Tooltip>
                <span className="text-success float-right font-weight-bold font-size-h1 mr-5">
                  {dashboardDetails.icons}
                </span>
              </span>
              <p className="text-success font-weight-bold font-size-h6 mt-2">
                Icons{" "}
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4">
            <div className="bg-light-warning px-14 py-8 rounded">
              <span className="svg-icon svg-icon-3x svg-icon-warning d-block my-2">
                <Tooltip title="FAQ">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/General/Clipboard.svg"
                    )}
                  />
                </Tooltip>
                <span className="text-warning float-right font-weight-bold font-size-h1 mr-5">
                  {dashboardDetails.faqs}
                </span>
              </span>
              <p className="text-warning font-weight-bold font-size-h6 mt-2">
                FAQ{" "}
              </p>
            </div>
          </div>
        </div>

        <div className="resize-triggers">
          <div className="expand-trigger">
            <div style={{ width: "400px", height: "461px" }} />
          </div>
          <div className="contract-trigger" />
        </div>
      </div>
    </div>
  );
}
